import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQAccordion() {
  const faqs = [{
    question: 'Is the hair restoration treatment painful?',
    answer: 'We prioritize your comfort. A topical numbing cream is applied before the treatment, making the process highly tolerable. Most patients describe it as a series of tiny, quick pinches.'
  }, {
    question: 'How many sessions will I need?',
    answer: 'While every patient is unique, we typically recommend an initial series of 3 to 4 sessions spaced about a month apart. Maintenance sessions are usually done once or twice a year to sustain your results.'
  }, {
    question: 'Who is a good candidate?',
    answer: "Our hair restoration treatment is highly effective for both men and women experiencing early to moderate hair thinning or hair loss. It works best when hair follicles are dormant but still present. During your free consultation, we'll assess your scalp to ensure this is the right treatment for you."
  }, {
    question: 'When will I see results?',
    answer: "Because we are working with your body's natural growth cycles, results take time. Most patients notice decreased shedding within the first month, with visible new growth and increased thickness appearing around months 3 to 4."
  }, {
    question: 'Is this different from a hair transplant?',
    answer: "Yes, completely. A hair transplant is a surgical procedure that moves hair follicles from one area to another. Our approach is a non-surgical, regenerative treatment that uses your own body's natural growth factors to stimulate the follicles you already have in place."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-20 md:py-32 px-4 border-t border-divider" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <h2 className="font-serif text-3xl md:text-5xl text-espresso text-center mb-12 md:mb-16" data-id="element-74">
          Frequently Asked Questions
        </h2>

        <div className="space-y-2" data-id="element-75">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-divider last:border-b-0" data-id="element-76">
                <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={() => toggleAccordion(index)} aria-expanded={isOpen} data-id="element-77">
                  <span className="font-serif text-xl md:text-2xl text-espresso pr-8 group-hover:text-gold transition-colors" data-id="element-78">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-sage flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-79" />
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-80">
                  <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed pr-8" data-id="element-81">
                    {faq.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}